<template>
  <div id="app">
    <RouteRenderer @roleId="permissionId=$event" @routeChanged="syncRoute"></RouteRenderer>
    <Sip ref="sip" id="SipElement" class="sip-client" @minimize="minimize" @isOnCalling="isOnCalling=$event" v-if="!isAuthRoute"></Sip>
    <Loading :inProgress="inProgress"></Loading>
    <Gdpr></Gdpr>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {mapActions,mapGetters} from 'vuex'
import Loading from '@/components/loading'
import Gdpr from '@/components/gdpr'
import Sip from '@/components/sip'
import RouteRenderer from '@/components/routeRenderer'
import axios from 'axios'
import "../static/dynamic-tabs/bootstrap-dynamic-tabs"
export default {
  name: 'App',
  beforeCreate(){
    if (this.$ && (!this.$.refs || Object.isFrozen(this.$.refs) || !Object.isExtensible(this.$.refs))) {
      this.$.refs = {}
    }
  },
  data (){
    return{
      permissionId:"",
      inProgress:false,
      isOnCalling:false,
      routeName: '',
      routePath: '',
    }
  },
  methods:{
    syncRoute(route){
      this.routeName = route.name || ''
      this.routePath = route.path || ''
    },
    minimize(type){
      if(type === 'minimize'){
        $('#SipElement').removeClass('sip-client');
        $('#SipElement').addClass('minimized-sip');
      }
      else {
        $('#SipElement').removeClass('minimized-sip');
        $('#SipElement').addClass('sip-client');
      }
    },
  },

  computed:{
        ...mapState([
            'windowWidth',
            'maxMobilSize'
        ]),
        ...mapGetters(['windowWidth']),
        isAuthRoute(){
          const authNames = ['login', 'loginTwoFactor', 'loginTwoFactorHelp', 'signup', 'forgotpassword', 'renewPassword', 'activation']
          return authNames.includes(this.routeName) || this.routePath === '/login' || this.routePath === '/signup'
        }
    },
  mounted(){
    window.addEventListener('resize', () => {
      this.$store.dispatch('windowWidth', window.innerWidth)
    })

    var that = this
    window.onbeforeunload = function() {
      if(that.isOnCalling==true) {
        return "If you reload this page, your previous action will be repeated";
      }
    }
  }, 
  components:{
    Loading,
    Gdpr,
    Sip,
    RouteRenderer
  },
  created(){
    const momentInstance = this.$moment || (this.$root && this.$root.$moment)
    if (momentInstance && momentInstance.locale && this.$ml && this.$ml.current) {
      momentInstance.locale(this.$ml.current)
    }

    axios.interceptors.request.use((config) => {
      
      try {
        //add blockLoadingBar=true parameter in your form data if you want to block loading gif
          if(config.data.blockLoadingBar!==true){
            this.inProgress=true
          }
      } catch (error) {

      }

      return config;
    }, (error) => {
      this.inProgress=false
      return Promise.reject(error);
    });

    axios.interceptors.response.use((response) => {
      this.inProgress=false
      return response;
    }, (error) => {
      this.inProgress=false
      return Promise.reject(error);
    });
  
  },
  watch:{
  }
}
</script>

<style>
  #app {
    position: relative;
  }
  .sip-client {
    position: fixed;
    z-index: 9999 !important;
    bottom: 2%;
    left: 50%;
    /* margin-bottom: -60px; Negative half of height. */
    margin-left: -350px; /* Negative half of width. */
  }
  .minimized-sip {
    position: fixed;
    z-index: 9999;
    top: 90%;
    left: 89%;
    margin-top: -32px; /* Negative half of height. */
    margin-left: -120px; /* Negative half of width. */
  }
</style>
